import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { StepHeader, StepNumberBadge } from '../ReservationSlotManagement.styles';

/**
 * SetupStepHeader のProps型
 *
 * @property {number} step - ステップ番号（バッジに表示）
 * @property {string} title - ステップの見出し
 * @property {string} description - 見出しの下に置く補足説明
 * @property {React.ReactNode} [action] - 右端に配置するアクション（ボタン等）。省略時は非表示
 */
export interface SetupStepHeaderProps {
  step: number;
  title: string;
  description: string;
  action?: React.ReactNode;
}

/**
 * 解放枠設定画面のSTEP見出し
 *
 * @description
 * 塗りつぶしのステップ番号バッジ・見出し・補足説明を横並びにし、
 * `action` が渡された場合のみ右端にアクション要素を配置する。
 *
 * @param {SetupStepHeaderProps} props - コンポーネントProps
 * @returns {React.ReactElement} STEP見出し
 */
const SetupStepHeader: React.FC<SetupStepHeaderProps> = memo(
  ({ step, title, description, action }) => (
    <StepHeader>
      <StepNumberBadge $filled>{step}</StepNumberBadge>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 13.5, fontWeight: 700 }}>{title}</Typography>
        <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.25 }}>
          {description}
        </Typography>
      </Box>
      {action != null && <Box sx={{ ml: 'auto', flexShrink: 0 }}>{action}</Box>}
    </StepHeader>
  )
);

SetupStepHeader.displayName = 'SetupStepHeader';

export default SetupStepHeader;
